<template>
  <div class="onus-pre-cadastro">
    <h1 class="titulo-card fs-4">Pré-cadastro de ONUs</h1>
    <div class="form-group card-principal">
      <div class="d-flex justify-content-between">
        <div class="input-group mb-3 pe-1">
          <input
              v-on:keyup.enter="handleAdicionar()"
              v-model="form.gponSn"
              type="text"
              class="form-control"
              placeholder="GPON SN"
              aria-label="GPON SN"
              aria-describedby="button-addon2">
          <button v-on:click="handleAdicionar()" class="btn btn-success" type="button">
            <font-awesome-icon :icon="['fas', 'plus']" fixed-width class="me-1"/>
          </button>
        </div>
        <div class="input-group mb-3">
          <input
              v-on:keyup.enter="handlePesquisa()"
              type="text"
              class="form-control"
              placeholder="Pesquisar"
              aria-label="Pesquisar"
              aria-describedby="button-addon2">
          <button v-on:click="handlePesquisa()" class="btn btn-outline-secondary" type="button" id="button-addon2">
            <font-awesome-icon :icon="['fas', 'search']" fixed-width class="me-1"/>
          </button>
        </div>
      </div>
      <div class="d-flex">
        <table class="table table-sm-pc table-striped table-hover">
          <thead>
            <tr>
              <th>GPON SN</th>
              <th width="110"></th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="onu in onus" :key="onu.id">
                <td scope="row">{{onu.gponSn}}</td>
                <td class="text-end">
                  <button type="button" v-on:click="handleRemove(onu)" class="btn btn-danger btn-sm">
                    <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                  </button>
                </td>
              </tr>
            </tbody>
        </table>
      </div>
      <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>
    </div>
  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import model from '../model'

export default {
  name: 'OnusPreCadastro',
  components: {
    Paginador,
  },
  data() {
    return {
      paginador: model.paginador,
      onus: [],
      form: {
        gponSn: '',
      }
    }
  },
  methods: {
    handlePesquisa() {
      loading(true);

      api.get(`/rede-neutra/onus?${this.paginador.requestParams}`).then(res => {
        loading(false);
        this.onus = res.data.itens;
        this.paginador.pagina = res.data.paginacao.pagina;
        this.paginador.totalItens = res.data.paginacao.total;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    onChangePaginacao() {
      this.handlePesquisa();
    },

    handleRemove(onu) {
      dialogo.confirmacao(`Confirma remover o usuário <b>${onu.gponSn}</b>?`).then(() => {
        loading(true);

        api.delete(`/rede-neutra/onus/${onu.id}`).then(() => {
          loading(false);

          this.handlePesquisa();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },

    handleAdicionar() {
      const sendData = clone(this.form);

      loading(true);
      api.post('/rede-neutra/onus', sendData).then(() => {
        loading(false);
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },
  },

  created() {
    this.paginador = clone(model.paginador);
    this.handlePesquisa();
  }
}
</script>
